export default __webpack_public_path__ + "static/media/coverImage.10863ebe.jpeg";